<template>
  <div class="buy-button container">
    <a v-if="customerInfoURL" class="kefu" :href="customerInfoURL">
      <img src="../assets/images/goods/kefu.png" class="icon" />
      <p class="text">客服</p>
    </a>
    <van-button
      v-if="show"
      type="primary"
      :class="isVipButton && 'vip-button'"
      @click="clickButton"
      :disabled="isDisable"
    >
      <div v-if="allPrice">
        <div class="text-number">已选{{ radio }}个课程</div>
        <div class="all-money">
          <span>合计：</span>
          ¥{{ allPrice }}
        </div>
      </div>
      <div v-else>{{ buttonText }}</div>
    </van-button>
  </div>
</template>

<script>
import { isWXBrowser } from '@/utils/browser'

export default {
  name: 'FooterButtonCourse',
  props: ['buttonText', 'isDisable', 'customerInfoURL', 'isVipButton', 'allPrice', 'radio'],
  data() {
    return {
      show: true,
    }
  },
  methods: {
    clickButton() {
      this.$emit('clickButton')
    },
  },
  mounted() {
    if (this.getCurrentBrand.brand === 'xuandiao' && isWXBrowser()) {
      this.show = false
    }
  },
}
</script>

<style lang="scss" scoped>
.buy-button {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.65rem;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 0.01rem solid #eee;
  background-color: #fff;
  @include maxWidth();

  .kefu {
    .icon {
      width: 0.53rem;
      margin-left: 0.05rem;
    }

    width: 1.7rem;
    height: 1rem;
  }
}

.vip-button {
  background: linear-gradient(to right, #fee9bb, #f0cc8c);
  border: none;
  color: #6e3600;
  font-weight: bold;
}

.van-button {
  border-radius: 0.16rem;
  width: auto;
  padding: 0 1.15rem;
}

.text-number {
  font-size: 0.27rem;
  color: rgba($color: #fff, $alpha: 0.8);
}

.all-money {
  span {
    font-size: 0.32rem;
  }

  font-size: 0.37rem;
}
</style>
